import axios from "axios";
import auth from "./utils/auth";
import { Configuration } from "./environment/setup";

export class AxiosHelper {
  public static axiosInstance() {
    const instance = axios.create({
      baseURL: `${Configuration.BaseUrlApi}`,
      headers: {
        Authorization: "Bearer " + auth.getAuthToken(),
      },
    });

    return instance;
  }
}
